import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { observe } from 'mobx';
import { inject, observer } from 'mobx-react';

import FieldFactory from 'common/components/field-factory';
import DeleteButton from 'common/components/delete-button';
import EditOptions from './edit-options';
import GenreOptions from './genre-options';
import GenreModal from './genre-modal';

@inject('genreStore', 'formStore')
@observer
class GenreRow extends React.Component {
	render () {
		const { genre } = this.props;
		const { artwork, label } = genre;
		const artworkStyle = {
			backgroundImage: `url("/assets/public/s3/img/${ artwork }")`
		};

		return (
			<div className="cell shrink" data-ta={ `genre-${label}`}>
				<div className="grid-x">
					<div className="cell shrink">
							<p className="margin-0 primary-font playlist-tile-label">{ label }</p>
						{/* <div className="" style={ artworkStyle }>
						</div> */}
					</div>
				</div>
				<div className="grid-x">
					<GenreModal
						genre={ genre }
						buttonClassName="button clear"
					/>
					<div className="cell small-2" style={{marginTop: '2.7vh'}}>
						<EditOptions optionIcon="fas fa-list-music icon" optionType="create" genre={ genre }/>
					</div>
					<div className="cell small-2" style={{marginTop: '2.7vh'}}>
						<EditOptions optionIcon="fal fa-edit icon" optionType="edit" genre={ genre }/>
					</div>
					<div className="cell shrink">
						<DeleteButton
							orientation="right"
							warningText={ `Really delete ${ label } genre?` }
							onConfirmClick={ this.onConfirmClick }
						>
							<button
								data-ta="deleteGenreBtn"
								className="button alert clear padding-left-0"
							>
								<span className="fas fa-trash padding-0"></span>
							</button>
						</DeleteButton>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onConfirmClick () {
		const { genreStore, genre } = this.props;
		genreStore.deleteItem(genre);
	}
}

export default GenreRow;
